import React, { useState } from 'react'
import { Modal, Tabs, Tab, Form, Button, Card, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import isEmail from 'validator/lib/isEmail';

import Pagination from '../../common/Pagination';

//import setHeaderTitle from '../../../utils/setHeaderTitle';
import useDataCollection from '../../../hooks/useDataCollection';
import './PasteRecipientsModal.scss';

function PasteRecipientsModal({ handleClose, setRecipients }) {
    const [phase, setPhase] = useState('notPasted');
    const [pasted, setPasted] = useState('');
    const { t } = useTranslation();

    const accepted = useDataCollection({
		searchColumns: ['email'],
        sortBy: { column: 'timeCreated', type: 'date' },
		sortDirection: 'desc',
		key: 'email',
		limit: 10
	});

    const rejected = useDataCollection({
		searchColumns: ['email'],
		sortBy: { column: 'timeCreated', type: 'date' },
		sortDirection: 'desc',
		key: 'email',
		limit: 10
	});

    const _setEmails = () => {
        const splitRegEx = /[ \r\n,;"'</>=]+/;
        const splitted = pasted.split(splitRegEx);
        // const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gm; // eslint-disable-line no-useless-escape
        const accpectedValues = [];
        const rejectedValues = [];
    
        for (let i = 0; i < splitted.length; i++) {
            if (splitted[i].length >= 7) {
                if (isEmail(splitted[i]) && !splitted[i].match(/[åäö]/g)) {
                    if (accpectedValues.indexOf(splitted[i]) === -1) {
                        accpectedValues.push(splitted[i]);
                    }
                } else {
                    if (rejectedValues.indexOf(splitted[i]) === -1) {
                        rejectedValues.push(splitted[i]);
                    }
                }
            } else {
                if (rejectedValues.indexOf(splitted[i]) === -1 && splitted[i].length > 0) {
                    rejectedValues.push(splitted[i]);
                }
            }
        }

        if (accpectedValues.length) {
            accepted.setData(accpectedValues.map(a => ({ email: a })));
        }

        if (rejectedValues.length) {
            rejected.setData(rejectedValues.map(r => ({ email: r })));
        }

        setPhase('pasted');
    };

    const _addAccepted = () => {
        setRecipients(accepted.data.map(a => a.email));
        handleClose();
    };

    return (
        <Modal
            show
            backdrop="static"
            onHide={handleClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>{t('emails.paste_recipients')}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="paste-recipients">
                {phase === 'notPasted' ?
                    <>
                        <fieldset>
                            <Form.Control
                                as="textarea"
                                spellCheck="false"
                                rows={20}
                                value={pasted}
                                onChange={({ target }) => setPasted(target.value)}
                            />
                            <div>
                                <span className="text-muted">
                                    {t('emails.paste_recipients_info')}
                                </span>
                            </div>
                        </fieldset>

                        <hr />

                        <Button
                            variant="success"
                            disabled={!pasted.length}
                            onClick={_setEmails}
                        >
                            {t('emails.paste_recipients')}
                        </Button>
                    </>
                : null}

                {phase === 'pasted' ?
                    <>
                        <Tabs className="Tabs-Basic">
                            <Tab eventKey="accepted" title={t('emails.accepted') + ` (${accepted.data.length})`}>
                                <fieldset>
                                    {accepted.data.length
                                        ?
                                            <ValuesList
                                                title="Accepted"
                                                dataCollection={accepted}
                                                t={t}
                                            />
                                        :
                                            <div className="d-flex align-items-center justify-content-center text-muted p-5">
                                                {t('emails.no_accepted_values')}
                                            </div>
                                    }
                                </fieldset>
                            </Tab>
                            <Tab eventKey="rejected" title={t('emails.rejected') + ` (${rejected.data.length})`}>
                                <fieldset>
                                    {rejected.data.length
                                        ?
                                            <ValuesList
                                                title="Rejected"
                                                dataCollection={rejected}
                                            />
                                        :
                                            <div className="d-flex align-items-center justify-content-center text-muted p-5">
                                                {t('emails.no_rejected_values')}
                                            </div>
                                    }
                                </fieldset>
                            </Tab>
                        </Tabs>

                        <hr />

                        <Button
                            variant="secondary"
                            onClick={() => setPhase('notPasted')}
                            style={{ marginRight: '20px' }}
                        >
                            {t('emails.back_to_edit')}
                        </Button>
                        <Button
                            variant="success"
                            onClick={_addAccepted}
                            disabled={!accepted.data.length}
                        >
                            {t('emails.add_accepted')}
                        </Button>
                    </>
                : null}
            </Modal.Body>
        </Modal>
    );
}

const ValuesList = ({ title, dataCollection, t }) => (
    <>
        <div className="list-container">
            {dataCollection.filtered.map(({ email }) => (
                <RecipientItem
                    key={email}
                    email={email}
                />
            ))}
        </div>
        
        {dataCollection.filtered.length ?
            <Pagination
                pageCount={dataCollection.pageCount}
                forcePage={dataCollection.currentPage}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={dataCollection.setPage}
            />
        : null}
        {!dataCollection.filtered.length ?
            <div className="d-flex align-items-center justify-content-center text-muted p-5">
                {t('emails.no_values_found')}
            </div>
        : null}
    </>
);

const RecipientItem = ({ email }) => (
    <Card className="list-item">
        <Card.Body className="item">
            <Col sm={6}>
                <span className="item-name">
                    {email}
                </span>
            </Col>
        </Card.Body>
    </Card>
);

export default PasteRecipientsModal;


